import { Environment } from 'environments/environment.interface';

export const environment: Environment = {
  production: true,
  serverUrl: 'http://localhost:8080',
  mockServerUrl: '',
  infoMessageDuration: 3,
};
